import { render, staticRenderFns } from "./question-content.vue?vue&type=template&id=56390c49&scoped=true&"
import script from "./question-content.vue?vue&type=script&lang=js&"
export * from "./question-content.vue?vue&type=script&lang=js&"
import style0 from "./question-content.vue?vue&type=style&index=0&id=56390c49&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56390c49",
  null
  
)

export default component.exports